import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const featureSelector = createFeatureSelector('relatedProducts');
export const getVariantsReviewProducts = createSelector(featureSelector, (f) => f?.variants ?? null);
